import { GET, PATCH, POST } from "../../../../helper/xbi4RestFunctions";
export const get_timesheet_of_user_by_user_id = async (org_id: any,org_user_id:any,week_start_date:any,week_end_date:any) => {
  const path = `/orgs/${org_id}/get_timesheet/${org_user_id}?week_start_date=${week_start_date}&week_end_date=${week_end_date}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
